import React from "react";
import { AiOutlineDelete } from "react-icons/ai";
import {
  dateCartFormatter,
  replaceString,
} from "../../../utils/helpers/dataHelper";

export default function CarDocument({ cart, removeFromBag }) {
  return (
    <div>
      <div className="flex justify-between mb-4">
        <div className="mr-4">
          <div className="font-semibold text-md">
            {cart.documentTypeName}{" "}
            <span className="font-normal text-xs">
              ({replaceString(cart.documentFormat)})
            </span>
          </div>
          <div className="compass_color font-bold">N{cart.documentFee}</div>
        </div>
        <div className="text-right text-xs">
          <div className="">{dateCartFormatter(cart.createdDate)}</div>
          <div className="flex justify-end">
            <AiOutlineDelete
              color="red"
              size={20}
              onClick={() => removeFromBag(cart)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
